export default __webpack_public_path__ + "static/media/imagen-selecciona-una-opcion.9c43098b.png";